import React, { useEffect, useState } from 'react';
import OneTouristHotelView from '../views/OneTouristHotelView';
import OneTouristHotelMobileView from '../views/OneTouristHotelMobileView';
import { getTourData } from '../utils/getTourData';

const OneTouristHotel = ({
  hotel,
  departure,
  request_model,
  touroperators_excluded = [],
  discount = [],
  recomend_hotels = [],
  likes = [],
  carts = [],
  isAuth = false,
  onCart,
  onContinue,
  DEPART_DATA,
  getHotelInfo,
  hotelsIdWithReviews,
}) => {
  const [sort, setSort] = useState('price');
  const [localDeparture, setLocalDeparture] = useState('');

  useEffect(() => {
    setLocalDeparture(departure);
  }, []);

  const row = hotel;

  const checkPromo = (tour) => {
    return tour.promo == 1 || /promo|промо/.test(tour.tourname.toLowerCase());
  };

  let tours = [];
  if (request_model.promo == 2) {
    tours = row.tours.tour.filter((tour) => checkPromo(tour));
    row.tours.tour = tours;
  } else if (request_model.promo == 1) {
    tours = row.tours.tour.filter((tour) => !checkPromo(tour));
    row.tours.tour = tours;
  }

  if (touroperators_excluded && touroperators_excluded.length) {
    touroperators_excluded.map((touroperator_excluded) => {
      tours = row.tours.tour.filter((tour) => {
        return (
          parseInt(tour.operatorcode) != parseInt(touroperator_excluded.id)
        );
      });
      row.tours.tour = tours;
      if (tours.length) {
        row.price = tours[0].price;
      }
    });
  }

  const handleSetSort = (type = 'price') => {
    setSort(type);
  };

  const recomend =
    recomend_hotels.indexOf(`${row.hotelcode}`) != -1 ? true : false;
  let hasGeograftourReviews;

  if (hotelsIdWithReviews?.length > 0) {
    hasGeograftourReviews = hotelsIdWithReviews.includes(
      row.hotelcode.toString()
    );
  }

  const oneTouristHotelRender = () => {
    if (!row.tours.tour.length) {
      return <div className="hotel-empty"></div>;
    }
    return !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? (
      <OneTouristHotelView
        DEPART_DATA={DEPART_DATA}
        key={`hotel-${row.hotelcode}`}
        row={row}
        departure={row.departure ? row.departure : localDeparture}
        recomend={recomend}
        hasGeograftourReviews={hasGeograftourReviews}
        discount={discount}
        carts={carts}
        likes={likes}
        isAuth={isAuth}
        onCartUpdate={onCart}
        request_model={request_model}
        onContinue={onContinue}
        sort={sort}
        onSort={handleSetSort}
        tourData={getTourData(row, departure, request_model)}
        getHotelInfo={getHotelInfo}
      />
    ) : (
      <OneTouristHotelMobileView
        key={`m-${row.hotelcode}`}
        row={row}
        departure={row.departure ? row.departure : localDeparture}
        recomend={recomend}
        hasGeograftourReviews={hasGeograftourReviews}
        discount={discount}
        carts={carts}
        likes={likes}
        isAuth={isAuth}
        request_model={request_model}
        onCartUpdate={onCart}
        onContinue={onContinue}
        sort={sort}
        onSort={handleSetSort}
        tourData={getTourData(row, departure, request_model)}
        getHotelInfo={getHotelInfo}
      />
    );
  };
  return oneTouristHotelRender();
};

export default OneTouristHotel;
